import { Snackbar, Alert, SnackbarProps, AlertProps } from '@mui/material';

export interface ToastProps extends Omit<SnackbarProps, 'children'> {
  message: string;
  severity?: AlertProps['severity'];
  onClose?: () => void;
}

export const Toast = ({
  message,
  severity = 'info',
  autoHideDuration = 6000,
  onClose,
  ...props
}: ToastProps) => {
  return (
    <Snackbar autoHideDuration={autoHideDuration} onClose={onClose} {...props}>
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
